import React, { useContext } from "react"
import { AgreementContext } from "../../../../context/AgreementContext"

const CookiePolicy = () => {
  const { createAppLink } = useContext(AgreementContext)
  return (
    <>
      <p>
        Teache uses cookies, mobile identifiers, tracking URLs, log data, and
        similar technologies to help provide, protect, and improve the Teache
        Platform. This Cookie Policy (&ldquo;<strong>Policy</strong>&rdquo;)
        supplements the Teache&nbsp;
        <a href={createAppLink("/policies/privacy-policy")}>Privacy Policy</a>,
        explains how and why we use these technologies, and outlines your
        choices.
      </p>
      <p>
        <strong>Why Teache Uses These Technologies</strong>
      </p>
      <p>We use these technologies for a number of purposes, such as:</p>
      <ul>
        <li>
          to enable you to use and access the Teache Platform and the Payment
          Services
        </li>
        <li>
          to enable, facilitate, and streamline the functioning of and your
          access to the Teache Platform
        </li>
        <li>
          to better understand how you navigate through and interact with the
          Teache Platform and to improve the Teache Platform
        </li>
        <li>
          to serve you tailored advertising (such as on the Teache Platform, via
          emails, and on third-party websites)
        </li>
        <li>
          to show you content (e.g., advertisements) that is more relevant to
          you
        </li>
        <li>
          to monitor and analyze the performance, operation, and effectiveness
          of the Teache Platform and Teache advertisements
        </li>
        <li>
          to enforce legal agreements that govern the use of the Teache Platform
        </li>
        <li>
          for fraud detection and prevention, trust and safety, and
          investigations
        </li>
        <li>
          for our customer support, analytics, research, product development,
          and regulatory compliance.
        </li>
      </ul>
      <p>
        <strong>Cookies</strong>
      </p>
      <p>
        When you visit the Teache Platform, we may place cookies on your device.
        Cookies are small text files that websites send to your computer or
        other Internet-connected devices to identify your browser uniquely or to
        store information or settings in your browser. Cookies allow us to
        recognize you when you return. They also help us provide a customized
        experience and can enable us to detect certain kinds of fraud. In many
        cases, the information we collect using cookies and other tools is only
        used in a non-identifiable manner without reference to personal
        information. For example, we may use the information we collect to
        better understand website traffic patterns and optimize our website
        experience. In some cases, we associate the information we collect using
        cookies and other technology with your personal information. Our
        business partners may also use these tracking technologies on the Teache
        Platform or engage others to track your behavior on our behalf.
      </p>
      <p>
        There are two types of cookies used on the Teache Platform: (1)
        &ldquo;session cookies&rdquo; and (2) &ldquo;persistent cookies.&rdquo;
        Session cookies normally expire when you close your browser, while
        persistent cookies remain on your device after you close your browser
        and can be used again the next time you access the Teache Platform.
      </p>
      <p>
        In many cases, you can manage cookie preferences and opt out of having
        cookies and other data collection technologies used by adjusting the
        settings on your browser. All browsers are different, so visit your
        browser's &ldquo;help&rdquo; section to learn about cookie preferences
        and other privacy settings that may be available. Please note that
        removing or rejecting cookies or clearing local storage could affect the
        features, availability, and functionality of the Teache Platform.
      </p>
      <p>
        <strong>Flash Cookies</strong>
      </p>
      <p>
        We may use Flash Cookies, also known as Local Stored Objects, and
        similar technologies to personalize and enhance your online experience.
        A Flash cookie is a small data file placed on a computer using Adobe
        Flash technology. The Adobe Flash Player is an application that allows
        rapid development of dynamic content, such as video clips and animation.
      </p>
      <p>
        We use Flash cookies to personalize and enhance your online experience
        and to deliver content for Flash players. We may also use Flash cookies
        for security purposes, to gather certain website metrics, and to help
        remember settings and preferences. Flash cookies are managed through a
        different interface than the one provided by your web browser. To manage
        Flash cookies, please visit&nbsp; Adobe's website.
      </p>
      <p>
        If you disable Flash cookies or other similar technologies, please note
        that you may not have access to certain content and product features,
        such as your device remembering a Listing that you viewed during a
        previous visit.
      </p>
      <p>
        <strong>Pixel Tags, Web Beacons, and Trackers</strong>
      </p>
      <p>
        Pixel tags, web beacons, and tracking URLs are tiny graphic images
        and/or small blocks of code placed on website pages, ads, or emails that
        allow us to determine whether you performed a specific action. When you
        access these pages or when you open an email, these tools let us know
        you have accessed the web page or opened the email. These tools also
        help us measure responses to our communications and improve our web
        pages and promotions.
      </p>
      <p>
        <strong>Server Logs and Other Technologies</strong>
      </p>
      <p>
        We collect many different types of information from server logs and
        other technologies. For example, we collect information about the device
        you use to access the Teache Platform, your operating system type,
        browser type, domain, and other system settings, as well as the language
        your system uses and the country and time zone where your device is
        located. Our server logs also record the IP address of the device you
        use to connect to the Internet. An IP address is a unique identifier
        that devices need to identify and communicate with each other on the
        Internet. We may also collect information about the website you were
        visiting before you came to the Teache Platform and the website you
        visited after you left the Teache Platform. These tools help us improve
        user experience and deliver our services.
      </p>
      <p>
        <strong>Device Information</strong>
      </p>
      <p>
        We may use device-related information to authenticate users. For
        example, we may use your IP address, browser information, or other data
        provided by your browser or device to identify the device being used to
        access our platform. We may also use these device-related techniques to
        associate you with different devices that you may use to access our
        content, which may be used for fraud-protection purposes and to create
        better-targeted advertising.
      </p>
      <p>
        <strong>Third Parties</strong>
      </p>
      <p>
        Third parties, including Facebook, place technologies like pixels and
        SDKs on the Teache Platform. These technologies (1) help us analyze how
        you use the Teache Platform, such as by noting the third-party services
        from which you arrived, (2) market and advertise Teache services to you
        on the Teache Platform and third-party websites, (3) help us detect or
        prevent fraud or conduct risk assessments, and (4) collect information
        about your activities on the Teache Platform, other sites, and/or the
        ads you have clicked on. For example, to help us better understand how
        people use the Teache Platform, we work with a number of analytics
        partners, including Google Analytics. To prevent Google Analytics from
        using your information for analytics, you may install the Google
        Analytics Opt-Out Browser.
      </p>
      <p>
        Third parties, including Facebook, may also use such tracking
        technologies to collect or receive information from the Teache Platform
        and elsewhere and use that information to serve ads that they believe
        are most likely to be of interest to you and measure the effectiveness
        of their ads both on the Teache Platform and on other websites and
        online services. Targeting and advertising cookies we use may include
        Google and other advertising networks and services we use occasionally.
        Given the extent to which advertising technology is integrated into the
        Teache Platform, even if you opt out of tailored advertising, you may
        still receive advertising content. In this case, the advertising content
        will be tailored to something other than your interests. We also do not
        control any of these opt-out links and are not responsible for the
        availability or accuracy of these mechanisms. Users can opt out of the
        collection and use of information for ad targeting by updating their
        Facebook account ad settings and by contacting hello@teache.co with a
        description of their request and validation information.
      </p>
      <p>
        <strong>Third-Party Social Plugins</strong>
      </p>
      <p>
        The Teache Platform may use social plugins provided and operated by
        third parties, such as Facebook&rsquo;s &ldquo;Like&rdquo; Button. As a
        result, you may send information that you are viewing on a certain part
        of the Teache Platform to a third party. If you are not logged into your
        account with the third party, then the third party may not know your
        identity. If you are logged into your account with a third party, then
        the third party may be able to link information or actions about your
        interactions with the Teache Platform to your account with them. Please
        refer to the third party&rsquo;s privacy policies to learn more about
        its data practices.
      </p>
      <p>
        <strong>Your Choices</strong>
      </p>
      <p>
        Most browsers automatically accept cookies. However, you can modify your
        browser settings to decline cookies by visiting the &ldquo;Help&rdquo;
        portion of your browser&rsquo;s toolbar. While you may disable cookies
        through your browser settings, the Teache Platform currently does not
        respond to a &ldquo;Do Not Track&rdquo; signal in the HTTP header from
        your browser or mobile application due to a lack of standardization
        regarding how that signal should be interpreted.
      </p>
      <p>
        Flash cookies operate differently than browser cookies, and cookie
        management tools available in a web browser will not remove flash
        cookies. To learn more about how to manage flash cookies, you can visit
        the&nbsp; Adobe website.
      </p>
      <p>
        Your mobile device may allow you to control cookies through its settings
        function. Refer to your device manufacturer&rsquo;s instructions for
        more information.
      </p>
      <p>
        If you choose to decline cookies, some parts of the Teache Platform may
        not work as intended or may not work at all.
      </p>
    </>
  )
}

export default CookiePolicy
